function findUSZipCodes(text) {
    const regex = /(?:\b|\n)(\d{5}(?:-\d{4})?)(?=\s*[,.]?(?:\b|\n))/;
    const match = text.match(regex);
    return match ? { country: 'United States of America', pincode: match[1] } : false;
}
function findUKPostcodes(text) {
    const regex = /(?:\b|\n)(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2}))(?=\s*[,.]?(?:\b|\n))/;
    const match = text.match(regex);
    return match ? { country: 'United Kingdom', pincode: match[1] } : false;
}
function findCanadianPostcodes(text) {
    const regex = /(?:\b|\n)([A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d)(?=\s*[,.]?(?:\b|\n))/;
    const match = text.match(regex);
    return match ? { country: 'Canada', pincode: match[1] } : false;
}
function findFrenchPostcodes(text) {
    const regex = /(?:\b|\n)(\d{5})(?=\s*[,.]?(?:\b|\n))/;
    const match = text.match(regex);
    return match ? { country: 'France', pincode: match[1] } : false;
}
function findSpanishPostcodes(text) {
    const regex = /(?:\b|\n)((0[1-9]|[1-4]\d|5[0-2])\d{3})(?=\s*[,.]?(?:\b|\n))/;
    const match = text.match(regex);
    return match ? { country: 'Spain', pincode: match[1] } : false;
}
function findDutchPostcodes(text) {
    const regex = /(?:\b|\n)(\d{4}\s?[A-Za-z]{2})(?=\s*[,.]?(?:\b|\n))/;
    const match = text.match(regex);
    return match ? { country: 'Netherlands', pincode: match[1] } : false;
}
export function detectAddressCountry(text) {
    const detectionFunctions = [
        findUSZipCodes,
        findUKPostcodes,
        findCanadianPostcodes,
        findFrenchPostcodes,
        findSpanishPostcodes,
        findDutchPostcodes,
    ];
    for (const detectFunction of detectionFunctions) {
        const result = detectFunction(text || '');
        if (result) {
            return result;
        }
    }
    return false;
}
